export default __webpack_public_path__ + "5a607171f3ab70ead2e508f90fc2b419.png";